module.exports = __webpack_public_path__ + "img/ts-3-x-copy@3x.0927e74c.png";